var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScheduled = function SvgScheduled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.111 13.2H11v6h6.111v-6zM15.89 0v2.4H6.11V0H3.667v2.4H2.444C1.094 2.4.012 3.474.012 4.8L0 21.6C0 22.926 1.094 24 2.444 24h17.112C20.906 24 22 22.926 22 21.6V4.8c0-1.326-1.094-2.4-2.444-2.4h-1.223V0H15.89zm3.667 21.6H2.444V8.4h17.112v13.2z"
  })));
};
export default SvgScheduled;